import { useEffect } from 'react';

export default function useViewportValues() {
  useEffect(() => {
    const updateVh = () => {
      const isMobile = window.innerWidth <= 767;
      const headerHeight = isMobile ? 60 : 0;

      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

      if (window.visualViewport) {
        document.documentElement.style.setProperty(
          '--viewport-height',
          `${Math.round(window.visualViewport.height)}px`
        );
      }
    };

    updateVh();

    window.addEventListener('resize', updateVh);

    return () => {
      window.removeEventListener('resize', updateVh);
    };
  }, []);
}
